export const portfolioWatchlistAsyncModule = {
  importFn: () => import(/* webpackChunkName: "portfolio-watchlist" */ './portfolio-watchlist'),
  cacheKey: 'portfolio-watchlist',
}
